export enum SEO_ENUMS {
    PDP = 'pdp',
    PLP = 'plp',
    HOME = 'home',
    CMS = 'cms',
    SRP = 'srp',
    OTHER = 'other',
    BLOG = 'blog',
    BHome = 'bh',
    BCP = 'bcp',
    BDP = 'bdp',
    CBS = 'cbs',
    REWARDS = 'rewards',
    FOH = 'foh',
    STORELOCATOR = 'storelocator'
}
